import React from 'react'
import Link from '../Link'
import Language from '../Language'
import * as styles from './index.module.css'
import { dynamicSort } from '../../utils'

const SuperNav = ({ superNavLinks, langs, pageAlert }) => {
  return (
    <div className={styles.superNav}>
      <div
        className={[
          styles.superNavCol,
          !pageAlert || pageAlert.hideAlert ? styles.superNavNoAlert : '',
        ].join(' ')}
      >
        {pageAlert && !pageAlert.hideAlert && (
          <>
            {pageAlert.linkUrl ? (
              <a href={pageAlert.linkUrl} className={styles.alertContent}>
                {pageAlert.text && (
                  <span className={styles.alertContentDesktop}>
                    {pageAlert.text}
                  </span>
                )}
                {pageAlert.mobileText && (
                  <span className={styles.alertContentMobile}>
                    {pageAlert.mobileText}
                  </span>
                )}
              </a>
            ) : (
              <span className={styles.alertContent}>
                {pageAlert.text && (
                  <span className={styles.alertContentDesktop}>
                    {pageAlert.text}
                  </span>
                )}
                {pageAlert.mobileText && (
                  <span className={styles.alertContentMobile}>
                    {pageAlert.mobileText}
                  </span>
                )}
              </span>
            )}
            {pageAlert.linkUrl ? (
              <a href={pageAlert.linkUrl} className={styles.alertLink}>
                {pageAlert.ctaText && <span>{pageAlert.ctaText}</span>}
                &nbsp;&nbsp;
                <svg
                  width="7"
                  height="12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.667 6L0 1.2 1.167 0 7 6l-5.833 6L0 10.8 4.667 6z"
                  />
                </svg>
              </a>
            ) : (
              <span className={styles.alertLink}>{pageAlert.ctaText}</span>
            )}
          </>
        )}
      </div>

      <div className={[styles.superNavCol, styles.superNavLang].join(' ')}>
        {superNavLinks && (
          <div className={styles.superNavLinkCont}>
            {superNavLinks
              .sort(dynamicSort('order'))
              .map(({ label, defaultUrl, hide }, index) =>
                hide ? (
                  ''
                ) : defaultUrl ? (
                  <Link
                    key={index}
                    to={(defaultUrl += defaultUrl.endsWith('/') ? '' : '/')}
                  >
                    <span>{label}</span>
                  </Link>
                ) : (
                  <span key={index}>{label}</span>
                )
              )}
          </div>
        )}
        <Language langs={langs} id={'shortLang'} />
      </div>
    </div>
  )
}

export default SuperNav
